import { Classes, Icon, Tab, Tabs } from "@blueprintjs/core"
import dayjs from "dayjs"
import { ADD_UPDATE_DISPATCH } from "graphql/dispatch/dispatch.mutations.gql"
import {
  CONFIRMED_ORDER_LIST,
  DISPATCHES_FOR_DATE,
} from "graphql/dispatch/dispatch.queries.gql"
import { getErrors } from "hooks/useErrors"
import dispatchModel from "models/dispatch.model"
import { Row } from "pages/order/detail/InvoiceSummary"
import React from "react"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { RESET_STATE } from "store/dispatch.redux"
import AppToaster from "utils/AppToaster"
import classNames from "utils/classNames"
import { calculateDiscount } from "utils/discount"
import { inr } from "utils/formatters.utils"
import { graphqlError } from "utils/parseError"
import CustomDialog from "../Atoms/CustomDialog"
import ButtonMutation from "../Molecules/ButtonMutation"

const CreateTripDialog = ({
  isOpen,
  onClose,
  disabled,
  dc,
  search,
  date,
  data,
  orders,
  orderItems,
  totalUnits,
  summaryAllOrders,
}) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const newOrders = []
  var totalOrderValue = 0
  var totalItemsCount = 0
  var totalCrateCount = 0
  const totalAmount = orderItems.reduce(
    (s, i) => s + (i.quantity * i.rate - i.discount),
    0
  )

  orders.forEach(order => {
    var orderValue = 0
    order.orderItems.forEach(i => {
      const orderItemsPercent =
        JSON.parse(i?.metadata || "{}")?.custom_discount_percent || 0
      const orderItemsFlat =
        JSON.parse(i?.metadata || " {}")?.custom_discount_flat || 0
      const discount = calculateDiscount({
        amount: i.quantity * i.rate,
        flat: orderItemsFlat || i?.discount?.flat,
        percent: orderItemsPercent || i?.discount?.percentage,
      })
      orderValue += i.quantity * i.rate - discount
    })
    const orderPercent =
      JSON.parse(order?.metadata || " {}")?.custom_discount_percent || 0
    const orderFlat =
      JSON.parse(order?.metadata || "{}")?.custom_discount_flat || 0
    const orderDiscount = calculateDiscount({
      amount: orderValue,
      flat: order?.discount?.flat || orderFlat,
      percent: order?.discount?.percentage || orderPercent,
    })

    // const tax = order.taxes.reduce((s, tax) => {
    //   return s + tax?.percentage
    // }, 0)

    newOrders.push({
      orderId: order.id,
      trackingCode: order.trackingCode,
      vendorName: order.user.fullName,
      deliveryAddress: order.shippingAddress.village,
      crateCount: order.crateCount,
      itemCount: order.orderItems.length,
      orderValue,
      orderDiscount,
      // tax,
    })
    totalOrderValue += orderValue
    totalItemsCount += order.orderItems.length
    totalCrateCount += order.crateCount
  })

  const totalOrderDiscount = newOrders.reduce((s, i) => s + i.orderDiscount, 0)
  const totalTax = orderItems.reduce((s, i) => s + i.taxAmount, 0)
  const totalShipping = orders.reduce((s, i) => s + (i.shippingCharges || 0), 0)
  const totalDiscountAmount = totalAmount - totalOrderDiscount
  const finalAmount = totalDiscountAmount + totalTax + totalShipping

  const getPriceBreakup = () => {
    return (
      <div className="flex justify-between">
        <section className="vt-invoice-summary">
          <Row className="mt-6" name="Sub-Total" value={totalAmount} />
          <Row
            className="mt-2"
            name="Discount Coupon"
            value={totalOrderDiscount}
          />
          <Row className="mt-2" name={"Shipping"} value={totalShipping} />
          <Row className="mt-2" name={"GST"} value={totalTax} />
          <hr className="my-2" />
          <Row
            className="mt-2 vt-total"
            name="Grand Total"
            value={finalAmount}
          />
        </section>
      </div>
    )
  }
  const SummaryPanel = () => (
    <div className={Classes.TEXT_SMALL}>
      <div style={{ marginLeft: "10px" }}>
        <span className="font-bold">Date - </span>
        <span>{data?.date}</span>
      </div>

      <div style={{ marginTop: "8px", marginLeft: "10px" }}>
        <span className="font-bold">Driver - </span>
        <span>
          {data?.driver}({data?.driverNumber})
        </span>
      </div>

      <div style={{ marginTop: "8px", marginLeft: "10px" }}>
        <span className="font-bold">Selected order count - </span>
        <span>{orders?.length}</span>
      </div>

      {totalCrateCount > 0 && (
        <div style={{ marginTop: "8px", marginLeft: "10px" }}>
          <span className="font-bold">Total Crates - </span>
          <span>{totalCrateCount}</span>
        </div>
      )}

      <div style={{ marginTop: "8px", marginLeft: "10px" }}>
        <span className="font-bold">Orders remaining - </span>
        <span>{summaryAllOrders?.statusReadyForSchedule - orders?.length}</span>
      </div>

      <div style={{ marginTop: "8px", marginLeft: "10px" }}>
        <span className="font-bold">Estd. start time - </span>
        <span>
          {dayjs(data?.estimatedStartTime).format("DD MMM YY, h:mm:ss a")}
        </span>
      </div>

      <hr />

      <div className="grid grid-cols-3 gap-4 justify-center">
        <div className="col-span-1 center-vertical">
          <span>{data?.source}</span>
        </div>
        <div className="col-span-1 center-vertical">
          <Icon icon="arrow-right" iconSize={20} />
        </div>
        <div className="col-span-1 center-vertical">
          <span>{data?.destination}</span>
        </div>
      </div>

      <hr />

      <table
        className={classNames(
          "vt-bulk-update-summary-table pr-6",
          Classes.TEXT_SMALL
        )}
      >
        <thead className="vt-bulk-update-table-header">
          <tr>
            <th>Item name</th>
            <th>Quantity</th>
            <th>Actual Rate</th>
            <th>Discounted Rate</th>
            <th>Sum</th>
            <th>Discount coupon</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody className="vt-bulk-update-table-body">
          {orderItems.map(item => {
            return (
              <tr key={item.id}>
                <td>{item.name}</td>
                <td>{item.quantity}</td>
                <td>{inr(item.actualRate || 0)}</td>
                <td>{inr(item.rate)}</td>
                <td>{inr(item.quantity * item.rate)}</td>
                <td>{inr(item.discount)}</td>
                <td>{inr(item.quantity * item.rate - item.discount)}</td>
              </tr>
            )
          })}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={1}></td>
            <td className="font-bold">{totalUnits}</td>
            <td colSpan={4}></td>
            <td className="font-bold">{inr(totalAmount)}</td>
          </tr>
        </tfoot>
      </table>
      {getPriceBreakup()}
    </div>
  )

  const OrdersPanel = () => (
    <div className={Classes.TEXT_SMALL}>
      <table
        className={classNames(
          "vt-bulk-update-summary-table pr-6",
          Classes.TEXT_SMALL
        )}
      >
        <thead className="vt-bulk-update-table-header">
          <tr>
            <th>Order ID</th>
            <th>Vendor name</th>
            <th>Delivery address</th>
            {totalCrateCount > 0 && <th>Crate count</th>}
            <th>Item count</th>
            <th>Order value</th>
          </tr>
        </thead>
        <tbody className="vt-bulk-update-table-body">
          {newOrders.map(order => (
            <tr key={order.orderId}>
              <td>{"# " + order.trackingCode}</td>
              <td>{order.vendorName}</td>
              <td>{order.deliveryAddress}</td>
              {totalCrateCount > 0 && <td>{order.crateCount}</td>}
              <td>{order.itemCount}</td>
              <td>{inr(order.orderValue)}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={3}></td>
            <td className="font-bold">{totalItemsCount}</td>
            <td className="font-bold">{inr(totalOrderValue)}</td>
          </tr>
        </tfoot>
      </table>

      {getPriceBreakup()}
    </div>
  )

  return (
    <CustomDialog
      canOutsideClickClose={false}
      title={
        <span>
          <span className="vt-muted">Vehicle - </span>
          {data?.vehicleNo ?? "NA"}
        </span>
      }
      isOpen={isOpen}
      rounded={true}
      onClose={onClose}
      light={true}
      icon="truck"
      width="653px"
      footerRightButton={
        <ButtonMutation
          disabled={disabled}
          refetchQueries={[
            {
              query: DISPATCHES_FOR_DATE,
              variables: {
                distributionCentreId: dc?.id,
                date: data?.date,
                first: 15,
                skip: 0,
              },
            },
            {
              query: CONFIRMED_ORDER_LIST,
              variables: {
                query: search,
                filter: {
                  date_Lte: date,
                  date_Gte: date,
                  orderStatus: ["RFS"],
                },
              },
            },
          ]}
          validate={state => {
            const errors = getErrors({
              schema: dispatchModel,
              state,
              abortEarly: true,
            })

            if (!state?.id && !state.organisationUserId) {
              AppToaster.show({
                message:
                  "Please specify the user under whom the dispatch will be created (Dispatch Under)",
                intent: "danger",
                icon: "cross",
              })
              return false
            }
            if (errors?.latest) {
              AppToaster.show({
                message: errors?.latest,
                intent: "danger",
                icon: "cross",
              })
              return false
            }
            return true
          }}
          onError={err => {
            AppToaster.show({
              message: graphqlError(err.message),
              intent: "danger",
              icon: "cross",
            })
          }}
          onCompleted={() => {
            AppToaster.show({
              message: "Trip created successfully!",
              intent: "success",
              icon: "tick",
            })
            dispatch({
              type: RESET_STATE,
            })
            navigate("/d/ecom/dispatch")
          }}
          mutation={ADD_UPDATE_DISPATCH}
          variables={data}
          dark
          icon="endorsed"
          text="Confirm"
        />
      }
    >
      <div>
        <Tabs>
          <Tab id="summary" title="Summary" panel={<SummaryPanel />} />
          <Tab id="orders" title="Orders" panel={<OrdersPanel />} />
        </Tabs>
      </div>
    </CustomDialog>
  )
}

export default CreateTripDialog
